"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Forms = require("./Forms");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const RelationPicture = props => {
  const {
    value,
    fetched,
    fetching,
    format,
    edit,
    entity,
    row
  } = props;
  if (edit) return /*#__PURE__*/_react.default.createElement(_Forms.RelationPicture, props);
  let imageType;
  let imageShape;
  if (entity && entity.singular) {
    switch (entity.singular.toLowerCase()) {
      case 'user':
        imageType = 'user';
        imageShape = 'round';
        break;
      case 'category':
        imageType = 'category';
        imageShape = 'square';
        break;
      case 'showroom':
        imageType = 'showroom';
        imageShape = 'square';
        break;
      case 'vishowcontentfile':
        imageShape = 'square';
        switch (row.Type) {
          case 3:
            imageType = 'pdf';
            break;
          case 4:
            imageType = 'image';
            break;
          case 6:
            imageType = 'video';
            break;
          default:
            imageType = 'image';
            break;
        }
        break;
      default:
        imageType = 'image';
        imageShape = 'square';
        break;
    }
  }
  if (value) {
    switch (format) {
      case 'base64':
        return /*#__PURE__*/_react.default.createElement("div", {
          className: `avatar-wrapper-small-${imageShape}`
        }, /*#__PURE__*/_react.default.createElement("span", {
          alt: "",
          className: `avatar-${imageShape} avatar-${imageType}`,
          style: {
            backgroundImage: `url(data:image/png;base64,${value.Data})`
          }
        }));
      default:
        return /*#__PURE__*/_react.default.createElement("div", null, "Image");
    }
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `avatar-wrapper-small-${imageShape}`
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: `avatar-${imageShape} avatar-${imageType}`,
    style: value ? {
      backgroundImage: `url(data:image/png;base64,${value.Data})`
    } : {}
  }));
};
var _default = exports.default = RelationPicture;
module.exports = exports.default;